import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import store from "@/store";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { DesktopPanelTheme, MobilePanelTheme } from ".";


export default /*@__PURE__*/_defineComponent({
  __name: 'panel',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const accountId = computed(() => route.params.id as string);

const menuDefault = computed(() => [
  {
    key: "accounts",
    icon: "change",
    label: t("common.labels.change_account"),
    url: "/accounts",
  },
  {
    key: "plans",
    icon: "plans",
    label: t("common.labels.plans"),
    url: "/plans",
  },
]);

const menuTechnical = computed(() => [
  {
    key: "home",
    icon: "home-line",
    label: t("common.labels.home"),
    url: `/${accountId.value}/home`,
  },
  {
    key: "evaluate",
    icon: "evaluate",
    label: t("common.labels.evaluations"),
    url: `/${accountId.value}/evaluate`,
  },
  // {
  //   key: "report",
  //   icon: "reports",
  //   label: t("common.labels.reports"),
  //   url: `/${accountId.value}/report`,
  // },
]);

const menuAdmin = computed(() => [
  {
    key: "home",
    icon: "home-line",
    label: t("common.labels.home"),
    url: `/${accountId.value}/home`,
  },
  {
    key: "cockpit",
    icon: "cockpit",
    label: t("common.labels.cockpit"),
    url: `/${accountId.value}/cockpit`,
  },
  {
    key: "evaluate",
    icon: "evaluate",
    label: t("common.labels.evaluations"),
    url: `/${accountId.value}/evaluate`,
  },
  {
    key: "register",
    icon: "add-form",
    label: t("common.labels.registrations"),
    url: `/${accountId.value}/register/company`,
  },
]);

const menuList = computed(() => {
  if (
    store.getters.type === "OWNER" ||
    store.getters.type === "ADMIN" ||
    store.getters.type === "MANAGER"
  )
    return menuAdmin.value;

  if (store.getters.type === "TECHNICAL" || store.getters.type === "ASSISTANT")
    return menuTechnical.value;

  return menuDefault.value;
});

return (_ctx: any,_cache: any) => {
  return (!_ctx.$store.getters.mobile)
    ? (_openBlock(), _createBlock(_unref(DesktopPanelTheme), {
        key: 0,
        "menu-list": menuList.value
      }, {
        main: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["menu-list"]))
    : (_openBlock(), _createBlock(_unref(MobilePanelTheme), {
        key: 1,
        "menu-list": menuList.value,
        "account-id": accountId.value
      }, {
        main: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["menu-list", "account-id"]))
}
}

})